import { matchValues } from '@shared/core/types/common';

const overlay: OLO.Config.HeroBackground['overlay'][] = ['full', 'half-angled'];

export const overlayType = matchValues(...overlay);
